import { render } from "./ReceiptChargeLink.vue?vue&type=template&id=1a1e726e&ts=true"
import script from "./ReceiptChargeLink.vue?vue&type=script&lang=ts"
export * from "./ReceiptChargeLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__